import ctl from '@netlify/classnames-template-literals';
import styles from '../inputBase.tailwind';

export const inputStyle = ctl(`${styles.inputBase}`);
